import { render, staticRenderFns } from "./Recount__plotsBvTaxAdd.vue?vue&type=template&id=4a8a3e96&scoped=true&"
import script from "./Recount__plotsBvTaxAdd.vue?vue&type=script&lang=js&"
export * from "./Recount__plotsBvTaxAdd.vue?vue&type=script&lang=js&"
import style0 from "@/style/flex.css?vue&type=style&index=0&id=4a8a3e96&scoped=true&lang=css&"
import style1 from "@/style/input.css?vue&type=style&index=1&id=4a8a3e96&scoped=true&lang=css&"
import style2 from "./Recount__plotsBvTaxAdd.vue?vue&type=style&index=2&id=4a8a3e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a3e96",
  null
  
)

export default component.exports